import { useMemo, memo, useCallback } from 'react';
import clsx from 'clsx';

// Imports => Constants
import {ICONS} from '@opp/ui-kit';

// Imports => Atoms
import {AcButton, AcIcon} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import styles from './ac-compliance-requirement-notice.module.scss';

const AcComplianceRequirementNotice = ({data, t}) => {
  const history = useHistory();

  const isReady = useMemo(() => {
    return data;
  }, [data]);

  const getMainClassNames = useMemo(() => {
    return clsx(styles.acNotice, isReady && styles.ready);
  }, [isReady]);

  const goToProfileDetails = useCallback(
    () => {
      const {replace} = history;
      replace('/profile#details');
    }, []
  );

  return (
    <header
      id={'ac-compliance-requirement-notice'}
      className={getMainClassNames}
      onClick={goToProfileDetails}
    >
      <div className={styles.noticeText}>
        <AcIcon className={styles.icon} icon={ICONS.ALERT_OCTAGRAM_OUTLINE} />
        {t('open-compliance-requirements', 'To transfer funds to your bank account, please provide necessary information to verify your account', {ns: 'common'})}
      </div>
      <AcButton className={styles.noticeButton} onClick={goToProfileDetails}>
        <span>{t('click-here-to-verify', 'Click here to verify', {ns: 'common'})}</span>
        <AcIcon icon={ICONS.OPEN_IN_NEW} />
      </AcButton>
    </header>
  );
};

export default withTranslation(['common'])(memo(AcComplianceRequirementNotice));
